import { Model } from '@/models/Model';
export class Plan extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Plan';
        this.$endpoint = '/plan';
        this.$fillable = [];
    }
}
export var PlanStatusEnum;
(function (PlanStatusEnum) {
    PlanStatusEnum["ACTIVE"] = "active";
    PlanStatusEnum["INACTIVE"] = "inactive";
})(PlanStatusEnum || (PlanStatusEnum = {}));
export const PlanStatusItems = [
    {
        value: PlanStatusEnum.ACTIVE,
        text: 'Active',
    },
    {
        value: PlanStatusEnum.INACTIVE,
        text: 'Inactive',
    },
];
